var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-simple",style:(_vm.defineStyle)},[_c('p',[_vm._v("\n        "+_vm._s(_vm.textButton)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }